import { FelaCSS, colors } from '@bridebook/ui';

interface IStyles {
  iconWrap: FelaCSS;
  awardWrap: FelaCSS;
  textWrap: FelaCSS;
}

const styles = (): IStyles => ({
  iconWrap: {
    justifyContent: 'center',
    marginRight: 2,
    width: '15px',
  },

  awardWrap: {
    ':not(:last-of-type)': {
      marginBottom: 4,
    },
  },

  textWrap: {
    color: colors.space,

    ':visited': {
      color: colors.space,
    },

    ':hover': {
      color: colors.space,
    },

    ':focus': {
      color: colors.space,
    },

    ':active': {
      color: colors.space,
    },
  },
});

export default styles;
